import { jsx, jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { PrimaryButton } from "@crehana/ui";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const LOCALES = {
    es: {
        INTERNET_CONNECTION_ERROR: 'Ocurrió un error de conexión',
        RELOAD_PAGE: 'Recargar la página'
    },
    pt: {
        INTERNET_CONNECTION_ERROR: 'Ocorreu um erro de conexão',
        RELOAD_PAGE: 'Recarregue a página'
    }
};
const STRINGS = LOCALES.es;
class Loadable extends Component {
    componentDidMount() {
        const { delay } = this.props;
        if (delay) setTimeout(()=>{
            this.setState({
                pastDelay: true
            });
        }, delay);
        this.props.module().then((Cmp)=>{
            this.setState({
                LoadableComponent: Cmp.default
            });
        }).catch((e)=>{
            this.setState({
                error: true
            });
            console.error('Error to load the chunk', e);
        });
    }
    render() {
        const { LoadableComponent, pastDelay, error } = this.state;
        const { render, Loader, ErrorFallback, renderDefaultErrorFallback, loading, module, ...rest } = this.props;
        if (error) {
            if (ErrorFallback || renderDefaultErrorFallback) return ErrorFallback || /*#__PURE__*/ jsxs("div", {
                className: "flex flex-col items-center w-full p-16 text-center bg-base-lighter-16 sm:p-32",
                children: [
                    /*#__PURE__*/ jsx("h4", {
                        className: "mb-16 font-subtitle2",
                        children: STRINGS.INTERNET_CONNECTION_ERROR
                    }),
                    /*#__PURE__*/ jsx(PrimaryButton, {
                        className: "w-full sm:w-auto",
                        label: STRINGS.RELOAD_PAGE,
                        onClick: ()=>{
                            window.location.reload();
                        }
                    })
                ]
            });
            return null;
        }
        if (!pastDelay || loading || !LoadableComponent) return Loader || null;
        if (LoadableComponent) {
            if (render) return render(LoadableComponent);
            return /*#__PURE__*/ jsx(LoadableComponent, {
                ...rest
            });
        }
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            LoadableComponent: void 0,
            pastDelay: void 0 === this.props.delay,
            error: false
        };
    }
}
_define_property(Loadable, "defaultProps", {
    loading: false
});
const Loadable_Loadable = Loadable;
export default Loadable_Loadable;
